export default __webpack_public_path__ + "static/3-7b21cc040d249738c289a44e75af3138.png";